// Module
var code = "<svg width=\"18\" height=\"7\" viewBox=\"0 0 18 7\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"> <path d=\"M1 1.21387H17M1 5.7853H17\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/> </svg> ";
// Exports
module.exports = code;